module.exports = __webpack_public_path__ + "b361364141510085aa14671bbea1d208.png";